/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import MultiSelect from 'components/multiSelect';
import orderStyle from 'pages/orders/style';
import { useRecoilState } from 'recoil';
import { allowedServices } from 'utils';
import { catalogs, riCatalogs } from 'store';
import { OrderPayload } from 'pages/user-preferences/store';
import HelpImg from 'pages/provisioning/_components/helpImg';

export const CatalogService = ({ index }) => {
    const [catalogServiceArray, setCatalogServiceArray] = React.useState([]);
    const [cmpCatalogs] = useRecoilState(catalogs);
    const [cmpRiCatalogs] = useRecoilState(riCatalogs);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const sendSelectedValues = (selectedServices) => {
        const updatedRuleRows = [...order?.ruleRows];
        updatedRuleRows[index] = { ...updatedRuleRows[index], value: selectedServices };
        setOrder({
            ...order,
            ruleRows: updatedRuleRows,
        });
    };

    React.useEffect(() => {
        const allCatalogs = [
            ...cmpCatalogs?.filter((item) => allowedServices(item?.catalogDefinitionId)),
            ...cmpRiCatalogs?.filter((item) => allowedServices(item?.['reference-implementation-id'])),
        ];
        setCatalogServiceArray(
            allCatalogs?.map((app) => ({
                value: app?.displayName || app?.name,
                label: app?.catalogDefinitionId ? app?.catalogDefinitionId : app?.['reference-implementation-id'],
            }))
        );
    }, [cmpCatalogs, cmpRiCatalogs]);
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
            <MultiSelect
                key="catlogservice"
                data-testid="catalog-service"
                value={order?.ruleRows?.[index]?.value || []}
                options={catalogServiceArray}
                sx={{ ...orderStyle?.orderFilter?.seletedFieldlabel, width: '100%' }}
                label="Select one or more Services *"
                handleOnSelect={(value) => sendSelectedValues(value)}
                filterOptions={(options, state) => options?.filter((element) => element?.value?.toLowerCase()?.includes(state?.inputValue?.toLowerCase()))}
                renderTags={(val) => <Box sx={{ marginLeft: '10px' }} data-testid="catalog-service-text">{`${val?.length} Selected`}</Box>}
                isOptionEqualToValue={(option, value) => option.value === value.value}
            />
            {order?.ruleRows?.[index]?.ruleType && (
                <HelpImg title={<Box>Catalog is a list of products, services, or resources you can easily browse and request.</Box>} />
            )}
        </Box>
    );
};

CatalogService.propTypes = {
    index: PropTypes.number.isRequired,
};
export default React.memo(CatalogService);
